module.exports = "/static/assets/439cddb83c09b2be056ed9587a26ccf6.png";